export const API_BASE_URL = 'https://api.aicee.in';

export const extractLoginToken = (result) => {
    return result.token || (result.data && result.data.token);
};

export const extractStudentInfo = (result) => {
    return result.student || (result.data && result.data.student) || result.user || (result.data && result.data.user);
};

export const setAuthSession = (token, studentInfo) => {
    localStorage.setItem('user-token', token);
    localStorage.setItem('student-info', JSON.stringify(studentInfo));
};

export const getAuthToken = () => {
    return localStorage.getItem('user-token');
};

export const clearAuthSession = () => {
    localStorage.removeItem('user-token');
    localStorage.removeItem('student-info');
};
